import { render } from "./CategoriesSlideOverComponent.vue?vue&type=template&id=5b2de9bb"
import script from "./CategoriesSlideOverComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesSlideOverComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__